import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Navbar />
      <main data-testid="site-main" className="pt-24 md:pt-28">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
